import * as getTypes from '../get-types'
import * as actionTypes from '../action-types'
import * as mutationTypes from '../mutation-types'
import { trackCatalogSearch } from '@/helpers/analytics/track-catatog-search'
import { segmentModule } from '@/plugins/segment/SegmentModule'
import { TRACK_CATALOG_SEARCH } from '@/plugins/segment/SegmentConstants'
import { CatalogApi } from '@/cowboy/catalog/CatalogApi'

const state = {
  catalog: null,
  brands: new Map(),
  items: new Map(),
  catalogSearchParams: null,
  searchIsVisible: true
}

const getters = {
  [getTypes.GET_CATALOG]: state => state.catalog,
  [getTypes.GET_CATALOG_SEARCH_PARAMS]: state => state.catalogSearchParams,
  [getTypes.GET_SEARCH_IS_VISIBLE]: state => state.searchIsVisible,
  [getTypes.GET_CATALOG_BRANDS]: ({ brands }) => brands,
  [getTypes.GET_CATALOG_ITEMS]: ({ items }) => items
}

const actions = {
  async [actionTypes.SET_CATALOG] ({ commit }) {
    const catalog = (await CatalogApi.fetchCatalog()).toJSON()
    commit(mutationTypes.SET_CATALOG, catalog)
    commit(mutationTypes.SET_CATALOG_SEARCH_PARAMS, null)
  },
  [actionTypes.SET_CATALOG_SEARCH_PARAMS] (context, params) {
    context.commit(mutationTypes.SET_CATALOG_SEARCH_PARAMS, params)
    if (params) {
      segmentModule.track(TRACK_CATALOG_SEARCH, trackCatalogSearch(params))
    }
  },
  [actionTypes.SET_SEARCH_IS_VISIBLE] (context, isVisible) {
    context.commit(mutationTypes.SET_SEARCH_IS_VISIBLE, isVisible)
  }
}

const mutations = {
  [mutationTypes.SET_CATALOG] (state, catalog) {
    const { brands: catalogBrands } = catalog || {}
    const brands = catalogBrands || []

    state.catalog = catalog
    state.brands = new Map(brands.map(brand => [brand.brandID, brand]))
    state.items = new Map(
      brands
        .map(({ brandID, items }) =>
          (items || []).map(item => {
            item.brandID = brandID
            return [item.utid, item]
          })
        )
        .flat()
    )
  },
  [mutationTypes.SET_CATALOG_SEARCH_PARAMS] (state, params) {
    state.catalogSearchParams = params
  },
  [mutationTypes.SET_SEARCH_IS_VISIBLE] (state, isVisible) {
    state.searchIsVisible = isVisible
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
